import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

function CableTies() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
        <Helmet>
    <title>
        In-Ground Power Supply Units UAE | Outdoor Power Solutions | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides in-ground power supply units in the UAE for urban spaces, parks, market places, historic sites and public areas, supporting power, water, compressed air, video, audio and data connections."
    />

    <meta
        name="keywords"
        content="in-ground power supply units UAE, in ground power units UAE, outdoor power supply UAE, underground power supply units UAE, IGU UAE, public space power solutions UAE, outdoor electrical power units UAE, BS EN 124 power units UAE, IP66 power supply units UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/CableTies"
    />

    <meta
        property="og:title"
        content="In-Ground Power Supply Units UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Reliable in-ground power supply units for public spaces, parks, urban areas and outdoor applications with IP66-rated electrical components."
    />

    <meta
        property="og:url"
        content="https://saig.me/CableTies"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">In Ground Power Supply Units</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Strong and secure fastening solutions for cable installations.
                    </p>
                </div>
            </div>

            <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>In Ground Power Supply Units (IGU) </h2>
  <div className='line'></div>

                         <h3 className='text-left mb-[20px]'>YK Electric efficient in ground power supply units provide electricity for public spaces such as urban areas, historic sites, market places, town squares and parks without the hassle of temporary installations and messy wire network, thus making it an ideal choice for the architects, planners and end users. In ground power supply units are designed to provide power, water, compressed air, video, audio and data. The applicable British standard for IGU is BS EN 124:2015, with IP66 rating.</h3>


               </div>
               </div>
        

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>

                <div className='detail-div-left'>

                    <div className='main-img'>

                        <img src='/assets/inground2.png' />
                    </div>


                </div>

                <div className='detail-div-right'>
                   <ul className="mt-4 grid grid-cols-1 ">
                                       {[
                                         "Availability of electrical power in seconds",
  "Eliminates the requirement of messy cable networks",
  "Permanent in nature",
  "Ease of use",
  "Easy to open and close after use",
  "Dual locking arrangements to prevent accidents",
  "In built gas springs for automatic opening",
  "Protection against theft and intrusions",
  "Camouflage with the surroundings",
  "Maintenance free",
  "IP Rated electrical components",
  "100% units can be customised to meet local requirements",
  "No MOQ"
                
                                        
                                       ].map((item, i) => (
                                          <li
                              key={i}
                              className="flex items-start gap-3 rounded-lg  bg-white px-4 py-1  transition"
                            >
                              <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
                              <span className="text-gray-700 text-[18px] leading-relaxed text-left aplus">
                                {item}
                              </span>
                            </li>
                                       ))}
                                     </ul>
                                     
                                    
                </div>
            </div>
           <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>


                         <h3 className='text-left mb-[20px]'>For free technical consultation - WhatsApp us on the available link on our website home page or simply dial +971 52 783 0214, to fix an appointment</h3>
 <Link to="/product">
                                                            <button className="backbtn mt-6">
                                                              Back To Products
                                                            </button>
                                                          </Link>

               </div>
               </div>


        </>
    )
}

export default CableTies